// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"8d01e2b7","725":"38f5a51c"}[chunkId] + ".chunk.js";
};